export const TYPE_CSS = "css";

export enum ResourceType {
    Css,
    Js
};

export abstract class Resource {
    type: ResourceType;
    source: string;

    constructor(type: ResourceType, source: string) {
        this.type = type;
        this.source = source;
    }

    equals(resource: Resource) {
        return this.type === resource.type && this.source === resource.source;
    }

    abstract load(): Promise<void>;
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/resources/Resource.ts
 **/